module.exports = __webpack_public_path__ + "static/media/imdb.82ffdf02.jpg";